import React from 'react';

const Body = () => {
    return (
        <div id='aboutMe' className='mt-3 border p-1'>
            <h2 className='text-4xl font-semibold'>About Myself</h2>
            <div className='flex mt-2'>
                <div className='w-1/2 flex items-center'>
                    <div>
                        <p className='text-gray-300'> Hello, I'm Fazri. I am a student. I'm studying in Computer Science. <br />
                            I like Programming and wishing to be a great Programmer. I consider myself as a fully dedicated, dynamic, punctual, passionate, efficient, quick learner, and a quick responder.</p>
                    </div>
                </div>
                <div className='w-1/2 flex justify-center'>
                    <div className='text-gray-300'>
                        <h2 className='font-semibold text-xl'>My Skills</h2>

                        <p><strong>Expertise:</strong> HTML, CSS, Bootstrap, Tailwind, JavaScript, ES6.</p>
                        <p><strong>Comfortable:</strong> React.JS, Node.JS, Express, JSON, REST API, MongoDB.</p>

                        <p><strong>Familiar:</strong></p>

                        <p><strong>Tools:</strong> Git, VSCode, Netlify, Heroku, Firebase, DevTools, Discord.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Body;